var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSection3T3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.772949,
    y: 0.420654,
    width: 42.5553,
    height: 43.5047,
    rx: 2.007,
    fill: "#006380"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8237 15.5576V18.6125H30.0826V15.5576H14.8237ZM30.0826 27.777H14.8237V24.7221H30.0826V27.777ZM17.8774 25.4858H16.3505V27.0142H17.8774V25.4858ZM16.3505 17.85H17.8774V16.3215H16.3505V17.85ZM14.8237 23.1944H30.0826V20.1395H14.8237V23.1944ZM17.8774 20.9034H16.3505V22.4319H17.8774V20.9034Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection3T3);
export default __webpack_public_path__ + "static/media/section3t3.602a5c2be5bbcdcd33ca68c26dba7b42.svg";
export { ForwardRef as ReactComponent };